export default "__VITE_ASSET__9f39181f__"